import React from 'react';
import { useDispatch } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import Dialog from '../../../base/ui/components/web/Dialog';
import { setAudioCuesEnabledState } from '../../userdata/actions';
const ReenableAudioCuesDialog = () => {
    const dispatch = useDispatch();
    const _onSubmit = () => {
        dispatch(setAudioCuesEnabledState(true));
    };
    return (React.createElement(Dialog, { cancel: { translationKey: 'Nein' }, ok: { translationKey: 'Ja' }, 
        // eslint-disable-next-line react/jsx-no-bind
        onSubmit: _onSubmit, size: 'medium', titleKey: 'H\u00F6rbare Signale' },
        React.createElement("div", null,
            React.createElement("p", null, "Sollen die h\u00F6rbare Signale wieder eingeschaltet werden?"))));
};
export default translate(ReenableAudioCuesDialog);
